import { gql } from '@apollo/client'

export const GET_MSAL_URL_QUERY = gql`
  query GET_MSAL_URL_QUERY {
    activeDirectoryGetAdminAuthUrl
  }
`

export const GET_ACTIVE_DIRECTORIES_QUERY = gql`
  query GET_ACTIVE_DIRECTORIES_QUERY($pagination: PaginationInput!) {
    activeDirectories(pagination: $pagination) {
      data {
        id
        token {
          id
          mappings {
            id
            conditions {
              value
              action
              fieldName
            }
            transactions {
              id
              fieldName
              fieldValue
              transactionType
            }
          }
          filterMappings {
            id
            conditions {
              value
              action
              fieldName
            }
          }
        }
        displayName
      }
      pagination {
        pageSkip
        pageTake
        totalCount
      }
    }
  }
`
